import { truncateListingUpdated } from '@/src/components/features/property/lib/listingUtils';

type DateAgoLike = {
  date?: unknown;
  ago?: unknown;
};

type ListingHistoryLike = {
  activated?: unknown;
  lastUpdated?: unknown;
};

export type TrustSignalDisplay = {
  updatedText: string;
  updatedIso: string;
  showUpdated: boolean;
};

const EMPTY_DISPLAY: TrustSignalDisplay = {
  updatedText: '',
  updatedIso: '',
  showUpdated: false,
};

const toDateAgo = (value: unknown): { date?: number; ago?: string } => {
  if (!value || typeof value !== 'object') return {};
  const { date, ago } = value as DateAgoLike;
  const validDate = typeof date === 'number' && Number.isFinite(date) && date > 0 ? date : undefined;
  const validAgo = typeof ago === 'string' && ago.trim().length > 0 ? ago : undefined;
  return { date: validDate, ago: validAgo };
};

const toIsoString = (date: number): string => {
  try {
    return new Date(date).toISOString();
  } catch {
    return '';
  }
};

export const getTrustSignalDisplay = (history: ListingHistoryLike | null | undefined): TrustSignalDisplay => {
  if (!history || typeof history !== 'object') return EMPTY_DISPLAY;

  const activated = toDateAgo(history.activated);
  const lastUpdated = toDateAgo(history.lastUpdated);

  const updatedSource = lastUpdated.ago ? lastUpdated : activated;
  const truncatedAgo = updatedSource.ago ? truncateListingUpdated(updatedSource.ago) : '';
  const updatedText = truncatedAgo ? `Updated ${truncatedAgo}` : '';
  const updatedIso = updatedSource.date ? toIsoString(updatedSource.date) : '';

  return {
    updatedText,
    updatedIso,
    showUpdated: Boolean(updatedText),
  };
};
